var _style, _path, _path2, _path3, _path4, _g, _g2, _path5, _g3, _path6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 200",
    style: {
      enableBackground: "new 0 0 250 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:#494949;}\n\t.st3{fill:#CCCCCC;}\n\t.st4{fill:#666666;}\n\t.st5{fill:none;stroke:#666666;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#6C6C6C;}\n\t.st8{opacity:0.6;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.9377,
    y1: 70.5766,
    x2: 115.9377,
    y2: 164.7646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.2,117.7c0,44.6,42.1,47.1,51.8,47.1c1.3,0,2.6,0,3.9,0c9.7,0,51.8-2.5,51.8-47.1 c0-45.1-43.1-47.2-52.1-47.1c-1.1,0-2.2,0-3.3,0C105.3,70.5,62.2,72.6,62.2,117.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.9363,
    y1: 75.5004,
    x2: 115.9363,
    y2: 138.758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.8,117.7c0,8.2-1.5,15.2-4.6,21.1c-3.3-6.3-8.3-11.2-15-14.8c-10.7-5.7-22.6-6.3-27.2-6.3h-0.3 c-0.6,0-1.1,0-1.7,0c-0.6,0-1.1,0-1.7,0H114c-4.6,0-16.5,0.6-27.2,6.3c-6.7,3.6-11.8,8.5-15,14.8c-3.1-5.9-4.6-12.9-4.6-21.1 c0-16.9,6.6-29,19.6-35.9c10.7-5.7,22.6-6.3,27.2-6.3h0.3c0.6,0,1.1,0,1.7,0c0.6,0,1.1,0,1.7,0h0.3c4.6,0,16.5,0.6,27.2,6.3 C158.2,88.7,164.8,100.7,164.8,117.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.2,85.8V54.6c3.2-1,5.5-4.2,4.8-7.9c-0.5-2.7-2.7-4.9-5.5-5.5c-4.4-0.8-8.2,2.5-8.2,6.8 c0,3.1,2.1,5.8,4.9,6.6v31c-4.9-6.8-11-11.3-16.6-14.2c-13-6.9-27.2-7.6-32.7-7.6h-0.4c-0.5,0-1,0-1.6,0c-0.5,0-1.1,0-1.6,0H114 c-5.5,0-19.7,0.7-32.8,7.6c-5.5,2.9-11.5,7.3-16.3,13.9V54.6c3.2-1,5.5-4.2,4.8-7.9c-0.5-2.7-2.7-4.9-5.5-5.5 C59.9,40.4,56,43.7,56,48c0,3.1,2.1,5.8,4.9,6.6v31.2h0c-7.3,0-13.3,5.9-13.3,13.3v8.9c0,2.7,1.1,5.2,2.9,7 c1.3,1.3,2.9,2.2,4.7,2.6c0.7,0.2,1.5,0.3,2.2,0.3h1.7v-0.1c0-25,13-37.1,23.8-42.9c12.3-6.5,25.7-7.2,30.9-7.2h0.3 c1.1,0,2.2,0,3.2,0h0.4c5.2,0,18.6,0.7,30.9,7.2c10.9,5.7,23.8,17.9,23.8,42.9v0.1h2c0.7,0,1.3-0.1,2-0.2c1.9-0.4,3.7-1.3,5-2.7 c1.8-1.8,2.9-4.2,2.9-7v-8.9C184.5,91.7,178.5,85.8,171.2,85.8L171.2,85.8z M60,48c0-1.6,1.3-3,3-3s3,1.3,3,3c0,1.6-1.3,3-3,3 S60,49.6,60,48z M166.3,48c0-1.6,1.3-3,3-3c1.6,0,3,1.3,3,3c0,1.6-1.3,3-3,3C167.6,50.9,166.3,49.6,166.3,48z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140,140.5H92.1c-12.6,0-22.8-10.2-22.8-22.8v-2.6c0-12.6,10.2-22.8,22.8-22.8H140 c12.6,0,22.8,10.2,22.8,22.8v2.6C162.8,130.3,152.6,140.5,140,140.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 95.1,
    cy: 114.3,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 137,
    cy: 114.3,
    r: 6.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 111.9,
    y1: 130.7,
    x2: 123.4,
    y2: 129.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.6,28.2c0.8-3.3-0.5-6.5-4-8.1c-1-0.5-2.3-0.6-3.5-0.2c-1.3,0.4-2.4,1.1-3.4,1.9c-1.7,1.5-3.4,3-4.9,4.6 c-1.9,2.1-3.8,4.2-5.5,6.4c-1.4,1.8-2.7,3.6-4,5.4c-1.2,1.7-2.2,3.4-3.3,5.2c-0.7,1.2-1.4,2.4-2,3.6c-0.3,0.6-0.2,1,0.3,1.5 c0.8,0.6,1.5,1.1,2.3,1.7c0.6,0.4,1.1,0.3,1.6-0.2c0.9-0.9,1.8-1.9,2.8-2.8c2.2-2.1,4.5-4.1,6.8-6c2.9-2.3,5.8-4.4,8.9-6.3 c2-1.2,4-2.2,5.9-3.7C225.6,30.4,226.3,29.5,226.6,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.8,53.2c-1.1-0.5-2.8-0.6-4.5,0c-3,1.1-4.7,3.4-5.1,6.5c-0.4,3,1.2,5.8,3.9,7c1.4,0.6,2.8,0.7,4.2,0.5 c2.9-0.4,5.3-2.6,6-5.3C198.2,58.5,196.5,54.9,192.8,53.2z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M33.7,100.8c-1.7-0.8-1.2-2.9-3-4c-2.2-1.4-5.4,0-7,1c-0.4,0.2-3.4,2.2-4,6c-0.1,0.8-0.5,3.5,1,5 c1.3,1.3,3,0.8,6,1c1.4,0.1,4.6,1.1,11,3c4.8,1.5,6.3,2.1,9,2c3-0.1,4.6-0.8,5-1c3.2-1.5,4.6-4.2,5-5c0.4-0.7,0.8-1.7,1-3 c0.3-2.2-0.5-4-1-5c-0.4-0.8-0.9-2-2-3c-2.6-2.4-6.4-2.1-7-2c-2.6,0.3-2.9,1.4-9,4C35.7,101.1,34.7,101.3,33.7,100.8z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.3,97.6c-1.4-2.8,0.3-6.1,2.3-8.1c2.4-2.5,5.8-3.7,8.7-5.5c3.1-1.8,5.3-4.6,8.1-6.7 c2.7-2.1,6.3-3,8.4-5.8c3.5-4.6,2.9-12.3-0.7-16.6c-3.5-4.3-11.7-6.5-15.8-2c-4.4,4.7-0.2,11.6,4.2,14.7 c4.6,3.3,11.3,3,16.7,3.2c8,0.3,16,0.1,24.1-0.3c7.9-0.3,15.9-0.9,23.6-2.9c7.3-1.9,14.8-4,22.4-2.7c6.7,1.1,12.5,4.9,16,10.7 c0.8,1.3,1.5,2.7,2,4.2c0.6,1.8,3.5,1,2.9-0.8c-2-5.8-6.1-10.8-11.4-13.9c-6.1-3.5-13.3-4-20.2-3.1c-7.4,1-14.4,3.6-21.8,4.5 c-7.6,1-15.4,1.1-23,1.4c-6.7,0.2-13.5,0.2-20.2-0.3c-2.7-0.2-5.5-0.5-8-1.7c-2.4-1.2-4.4-3.5-5.5-5.9c-1.1-2.6-0.3-5.5,2.6-6.2 c2.6-0.7,5.8,0.2,7.9,1.8c2,1.5,3,3.8,3.4,6.2c0.5,2.8,0.2,6.1-1.7,8.3c-1.3,1.5-3.2,2.2-4.8,3.2c-1.6,0.9-3,1.9-4.4,3.1 c-1.4,1.3-2.8,2.7-4.3,3.9c-1.5,1.1-3.1,2-4.8,2.9c-3.2,1.7-6.2,3.5-8.3,6.6c-1.9,2.9-2.6,6.4-1,9.6 C39.6,100.8,42.2,99.3,41.3,97.6L41.3,97.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M161,146c-0.4,4.2-1,10.3,3,13.1c2.8,2,6.6,2.1,9.8,3.2c3.3,1.1,5.3,4.3,6.5,7.4c1.4,3.4,2.2,7.1,3.7,10.6 c1.7,4.1,4.3,7.6,8.4,9.7c1.7,0.9,3.2-1.7,1.5-2.6c-7-3.5-7.9-11.3-10.4-17.9c-1.3-3.3-3.1-6.7-6.1-8.7c-2.8-1.9-6.4-2-9.5-3 c-1.3-0.4-2.8-1.1-3.4-2.5c-0.5-1.2-0.6-2.7-0.6-4.1c-0.1-1.7,0-3.4,0.2-5.1C164.2,144.1,161.2,144.1,161,146L161,146z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M13.7,109.8c1.7-4,4.1-7.8,7.6-11.3c2.3-2.2,4.8-3.7,7.5-3.9c2.3-0.2,4.2,0.5,5.7,1.7c2,1.6,5,1.5,8.8,0 c2.9-1.2,5.9-2.1,8.9-2.3c4.9-0.3,8,1.5,9.2,5c1.6,4.6,0.8,9.9-1.7,15.2c-1.6,3.4-4.1,6.5-6.9,9.3c-2.3,2.3-6.1,2.8-8.3,1.2 c-0.9-0.7-1.7-1.5-2.2-2.4c-1.1-1.7-2-3.5-2.9-5.3c-0.5-1-1.3-1.6-2.6-1.9c-4.5-0.8-8.6-1.6-12.3-2.4c-1-0.2-1.8,0-2.8,0.6 c-2.1,1.3-4,2.5-6,3.1c-2.1,0.7-3.4-0.5-3-2.7C12.9,112.5,13.4,111.2,13.7,109.8z M25,102.2c-0.7,0-1.4-0.1-2-0.1 c-0.4,0-0.7,0.1-0.9,0.6c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.5-0.2,0.7,0.3,0.7c0.7,0,1.3,0.1,2,0.2c-0.4,0.9-0.8,1.7-1.1,2.6 c1,0.1,1.8,0.2,2.8,0.4c0.4-0.9,0.8-1.7,1.2-2.7c0.3,0,0.6,0.1,0.8,0.1c0.7,0,1.5,0.4,2,0c0.6-0.4,0.8-1.4,1.2-2.1 c0.3-0.6,0.2-0.8-0.3-0.8c-0.8,0-1.5-0.1-2.3-0.1c0.4-1,0.8-1.9,1.2-2.8c-1.1,0-2.1-0.1-3.1-0.1c-0.2,0.5-0.4,0.9-0.5,1.3 C25.5,101.2,25.3,101.6,25,102.2z M45,104.4c1.7,0.1,3.7-0.9,4.5-2.3c0.8-1.4-0.1-2.6-1.8-2.6c-1.7-0.1-3.7,1-4.4,2.4 C42.6,103.2,43.4,104.3,45,104.4z M50.9,108.8c1.8,0.2,4.1-0.8,5-2.2c0.9-1.5,0-2.8-2-2.9c-1.9-0.1-4.1,0.9-4.8,2.3 C48.3,107.4,49.1,108.6,50.9,108.8z M44,106.3c-1.6-0.2-3.4,0.7-4.1,2c-0.6,1.2,0,2.4,1.5,2.6c1.6,0.2,3.5-0.6,4.2-1.9 C46.4,107.7,45.7,106.5,44,106.3z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.9,54.6c3.2-1,5.5-4.2,4.8-7.9c-0.5-2.7-2.7-4.9-5.5-5.5C59.8,40.4,56,43.7,56,48c0,3.1,2.1,5.8,4.9,6.6 v8.1h3.9V54.6z M60,48c0-1.6,1.3-3,3-3c1.6,0,3,1.3,3,3s-1.3,3-3,3C61.3,50.9,60,49.6,60,48z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.9,
    y: 5.8,
    className: "st8",
    width: 229.6,
    height: 188
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasks);
export default __webpack_public_path__ + "static/media/no_tasks.0c2684e2bc69c0b666b444ce69c68825.svg";
export { ForwardRef as ReactComponent };